import { Entity } from '@backstage/catalog-model';

const isKind = (kind: string) => (entity: Entity) =>
  entity.kind.toLocaleLowerCase('en-US') === kind;

/** True for a Component entity. */
export const isComponent: (entity: Entity) => boolean = isKind('component');

/** True for an API entity. */
export const isApi: (entity: Entity) => boolean = isKind('api');

/** True for a Group (Squad) entity. */
export const isGroup: (entity: Entity) => boolean = isKind('group');

/** True for a System (Sistema) entity. */
export const isSystem: (entity: Entity) => boolean = isKind('system');

/** True for a User entity. */
export const isUser: (entity: Entity) => boolean = isKind('user');

/**
 * The kinds whose page is in the v2 design (Sprint 2 Componente, Sprint 3
 * API, Squad and Sistema): the overview grid and the pt-BR tab labels.
 */
export function hasV2Page(entity: Entity): boolean {
  return (
    isComponent(entity) || isApi(entity) || isGroup(entity) || isSystem(entity)
  );
}
